import { DetailListItemProps } from '@eika-kortbetjening/detail-list/lib/detail-list-item/DetailListItem';

import sitecoreSimulationData from '@/config/dictionary/sitecore-simulation-data';

import { Card, DebitAccount, Organisation, User } from '@generated-types';

import { getDebitCardDetails } from './getDetails';

const getDetailListItems = (
    card: Card,
    customer: User | Organisation,
    account: DebitAccount,
): DetailListItemProps[] => {
    return getDebitCardDetails(card, sitecoreSimulationData.text, customer, account).filter((i) => i !== null);
};

export default getDetailListItems;
